var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('time-line',{attrs:{"dataArr":_vm.flowData,"selfUserId":_vm.selfUserId},model:{value:(_vm.collapseValue),callback:function ($$v) {_vm.collapseValue=$$v},expression:"collapseValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }